// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__6itbF","col":"styles_col__1EP19","fulfillmentStatus":"styles_fulfillmentStatus__PZ8i2","emailCol":"styles_emailCol__1tyB1"};